<template>
  <div class="cf-page-container">
    <div
      v-if="orderHistory.isLoading"
      :class="['cf-container-full-width', { 'cf-page-loader': orderHistory.isLoading }]"
    >
      <div class="cf-loader" />
    </div>

    <div
      v-else
      class="cf-card cf-card--mobile cf-flex cf-flex--column cf-flex--gap-16"
    >
      <h1 class="cf-title cf-title--1">
        Order History
      </h1>

      <div
        v-if="orderHistory.orders.length === 0"
        class="cf-page-content-container cf-flex--gap-12 cf-text-align-center"
      >
        <h2 class="cf-title cf-title--2">
          Looks like you haven't ordered anything yet.
        </h2>

        <p class="cf-subtitle cf-subtitle--2">
          After you checkout, you can view your past orders here.
        </p>

        <button
          class="cf-button cf-button--primary cf-button--lg"
          type="button"
          @click="startOrderClickHandler"
        >
          Start An Order
        </button>
      </div>

      <div
        v-else
        class="cf-flex cf-flex--column cf-flex--gap-12"
      >
        <order-history-item
          v-for="order in orderHistory.parsedOrders"
          :key="order.orderId"
          :order-history-item="order"
        />
      </div>
    </div>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import OrderHistoryItem from './order-history-item/index.vue';


  export default {
    name: 'OrderHistoryPage',

    components: {
      OrderHistoryItem
    },

    metaInfo() {
      return {
        title: 'Order History'
      };
    },

    data() {
      return {
        reorderingOrderId: null
      };
    },

    computed: {
      ...mapGetters('orderHistory', ['orderHistory']),

      isRatingEnabled() {
        return true;
      }
    },

    created() {
      this.getOrderHistoryOrders();
    },

    methods: {
      async getOrderHistoryOrders() {
        await this.$store.dispatch('orderHistory/getOrders');
      },

      startOrderClickHandler() {
        this.$router.push({
          name: 'orderMenu',
          params: {
            merchantId: this.$route.params.merchantId
          }
        });
      }
    }
  };
</script>
